<template>
  <div class="testflight-modal">
    <div class="modal-container">
      <button class="close" @click="hideTestflightModal">&nbsp;</button>
      <div class="qrcode">
        <h3>{{ title }}</h3>
        <div class="notice">
          <div class="tf-step">{{ $t("testflight_step1") }}</div>
          <div class="btns">
            <a :href="testflightUrl" target="_blank" class="btn">
              <span class="label">1. {{ $t("download") }} TestFlight</span>
            </a>
          </div>
          <div class="tf-step">
            {{ $t("testflight_step2") }} <br /><br />
            {{ $t("testflight_step3") }}
          </div>
          <div class="btns">
            <a href="javascript:;" target="_blank" class="btn btn-download">
              <span class="label">2. {{ $t("download") }} JavDB App</span>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestflightModal",
  props: ["title"],
  data: function() {
    return {};
  },
  computed: {
    testflightUrl: function() {
      return this.$iosTestFlightUrl;
    }
  },
  methods: {
    hideTestflightModal: function() {
      this.$emit("hideTestflightModal");
    },
  },
  created: function() {},
};
</script>

<style lang="scss">
@import "../assets/style.scss";
.testflight-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.9);
  .modal-container {
    width: 100%;
    height: 100%;
    padding: 5rem 0 0 0;
    display: grid;
    place-items: start center;
    .qrcode {
      h3 {
        padding-bottom: 1rem;
      }
      max-width: 500px;
      z-index: 10;
      width: 100%;
      .notice {
        text-align: left;
        padding: 1rem 1rem;
        line-height: 1.4rem;
        width: 100%;
        .tf-step {
          padding-top: 1rem;
          padding-bottom: 1rem;
          &:first-child {
            padding-top: 0;
          }
        }
      }
   }
  }
}
@media (max-width: 400px) {
  .testflight-modal {
    .modal-container {
      .btns {
        .btn {
          padding: 0.1rem 0.8rem !important;
          .label {
            font-size: 1rem !important;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
